/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
// import Dashboard from "layouts/dashboard";
// import Tables from "layouts/tables";
// import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
// import Profile from "layouts/profile";
// import SignIn from "layouts/authentication/sign-in";
// import SignUp from "layouts/authentication/sign-up";

// // @mui icons
// import Icon from "@mui/material/Icon";
// import AuthLogin from "layouts/authentication/log-in";
// import AuthRegister from "layouts/authentication/register";
// import UserRegistration from "layouts/pages/UserRegistration";
// import JobForm from "layouts/pages/JobForm";
// import JobSearch from "layouts/pages/JobSearch";
// import HomePage from "layouts/pages/Landing";
// import Workflow from "layouts/pages/Workflow";
import { UserAddOutlined } from "@ant-design/icons";
import {
  AccountTree,
  Business,
  Work,
  Dashboard,
  Settings,
  DesignServices,
  TuneOutlined,
  Groups,
  BurstMode,
  FolderCopy,
} from "@mui/icons-material";

const menu = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  // },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/sign-in",
  //   component: <AuthLogin />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/sign-up",
  //   component: <AuthRegister />,
  // },
  // {
  //   type: "collapse",
  //   name: "Job Form",
  //   key: "job-creation",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/job-creation",
  // },
  {
    type: "collapse",
    name: "Jobs",
    key: "jobs",
    icon: <Work />,
    route: "/jobs",
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Dashboard />,
    route: "/dashboard",
  },
  {
    type: "collapse",
    name: "Applicants",
    key: "applicant-details",
    icon: <Groups />,
    route: "/applicant-details",
  },
  {
    type: "collapse",
    name: "Recently Joined",
    key: "resume-data",
    icon: <FolderCopy />,
    route: "/resume-data",
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <UserAddOutlined />,
    route: "/users",
  },
  {
    type: "collapse",
    name: "Company Profile",
    key: "company-profile",
    icon: <Business />,
    route: "/company-profile",
  },
  {
    type: "collapse",
    name: "Workflow",
    key: "workflow",
    icon: <AccountTree />,
    route: "/workflow",
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "configurations",
    icon: <DesignServices />,
    route: "/configurations",
  },
  {
    type: "collapse",
    name: "Application Config",
    key: "system-configuration",
    icon: <Settings />,
    route: "/system-configuration",
  },
  {
    type: "collapse",
    name: "Content Management",
    key: "content-management",
    icon: <BurstMode />,
    route: "/content-management",
  },
  {
    type: "collapse",
    name: "Access Control",
    key: "access-control",
    icon: <TuneOutlined />,
    route: "/access-control",
  },
];

export default menu;
